import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { get } from 'lodash'
import { handleMUIPreventCellKeyDown } from 'utils/datagrid'
import BulkMoveStopsDataGridPro from 'components/route-manager/BulkActions/common/BulkMoveStopsDataGridPro'
import RenderStopListItem from './RenderStopListItem'
import { ROW_HEIGHT } from './setings'

const StopsDataGrid = ({ apiRef, rows = [], loading = false, RenderCell = RenderStopListItem, ...rest }) => {
  const columns = [
    {
      field: 'id',
      renderCell: RenderCell,
      flex: 1,
      sortable: false,
      filterable: false,
    },
  ]

  const getRowId = row => get(row, 'id')
  const getRowClassName = params => (params.row.toBeInserted ? 'from-stop-to-be-assigned' : '')

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }} {...rest}>
      <Box sx={{ position: 'absolute', inset: 0 }}>
        <BulkMoveStopsDataGridPro
          sx={{
            p: 0,
            '& .MuiDataGrid-cell': {
              px: 1,
            },
          }}
          loading={loading}
          apiRef={apiRef}
          getRowId={getRowId}
          getRowClassName={getRowClassName}
          checkboxSelection={false}
          columnHeaderHeight={0}
          rowHeight={ROW_HEIGHT}
          columns={columns}
          rows={rows}
          onCellKeyDown={handleMUIPreventCellKeyDown}
        />
      </Box>
    </Box>
  )
}

StopsDataGrid.propTypes = {
  rows: PropTypes.array,
  apiRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  loading: PropTypes.bool,
  RenderCell: PropTypes.node,
}

export default StopsDataGrid
